import axios, { AxiosResponse } from 'axios'
import APIService from '@/api/services/APIService/APIServiceImpl'
import AccomodationServiceV1 from '@/api/services/AccomodationService/AccomodationServiceV1'

import { AccomodationResponseDTO } from "../../../../../requests-module"
import LocaleServiceImpl from '@/service/LocaleService/LocaleServiceImpl'


export default class AccomodationServiceV1Impl
    extends APIService
    implements AccomodationServiceV1 {
    constructor() {
        const serviceUrl = `https://api.travelski.com/catalog/lihe`
        //https://api.travelski.com/catalog/lihe/24164?details=prestations&locale=fr_FR
        super(serviceUrl)
    }

    async getDetails(liheId: string): Promise<AccomodationResponseDTO> {
        const localeService = new LocaleServiceImpl()
        const locale = localeService.getLocale()
        try {
            const headers = {
                ...this.getDefaultHeaders(),
            }
            const url = `${this.getServiceUrl()}/${liheId}?details=prestations&locale=${locale.replaceAll('-', '_')}`
            const response: AxiosResponse<AccomodationResponseDTO> = await axios.get(url, {
                headers,
            })
            return response.data;
        } catch (error) {
            throw new Error(`AccomodationServiceV1Impl - getDetails ${error}`)
        }
    }
}